import { render, staticRenderFns } from "./EmailRedirect.vue?vue&type=template&id=f6e3b584&scoped=true&"
import script from "./EmailRedirect.vue?vue&type=script&lang=js&"
export * from "./EmailRedirect.vue?vue&type=script&lang=js&"
import style0 from "./EmailRedirect.vue?vue&type=style&index=0&id=f6e3b584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e3b584",
  null
  
)

export default component.exports